import { TrendingUp } from 'lucide-react';

const AreasOfImprovement = ({
  areasOfImprovement
}: {
  areasOfImprovement: string[];
}) => {
  return (
    <div className='mt-4 rounded-lg bg-white p-4 shadow-lg sm:mt-6 sm:p-6'>
      <div className='mb-4 flex items-center space-x-3'>
        <TrendingUp className='h-5 w-5 text-amber-500 sm:h-6 sm:w-6' />
        <h2 className='text-lg font-semibold text-gray-900 sm:text-xl'>
          Areas of Improvement
        </h2>
      </div>
      <ul className='space-y-2.5'>
        {areasOfImprovement.map((area: any, idx: number) => (
          <li key={area} className='flex items-start space-x-3'>
            <span className='mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 text-xs font-bold text-amber-700'>
              {idx + 1}
            </span>
            <p className='text-sm leading-relaxed text-gray-700 sm:text-base'>
              {area}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AreasOfImprovement;
